export default "__VITE_ASSET__Ia1WBxXG__"